import { render } from "./HRSettings.vue?vue&type=template&id=4ac73bca&scoped=true&ts=true"
import script from "./HRSettings.vue?vue&type=script&lang=ts"
export * from "./HRSettings.vue?vue&type=script&lang=ts"

import "./HRSettings.vue?vue&type=style&index=0&id=4ac73bca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac73bca"]])

export default __exports__